import { render, staticRenderFns } from "./HokapatoList.vue?vue&type=template&id=d177a604"
import script from "./HokapatoList.vue?vue&type=script&lang=js"
export * from "./HokapatoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports